<template>
  <div class="home-page">
    <!-- ========== 顶部导航 ========== -->
  <!-- ========== 顶部导航（使用组件） ========== -->
<AppHeader />

<!-- ========== 轮播栏（导航下第一位，做大） ========== -->
<section class="carousel-section">
  <div class="carousel-container">
    <el-carousel 
      :interval="5000" 
      
      height="900px" 
      
      indicator-position="inside" 
      arrow="always" 
      class="main-carousel"
      @change="onCarouselChange"
    >
      <!-- 轮播项 1 -->
      <el-carousel-item v-for="(nav, idx) in slides" :key="nav.id || ('fb' + idx)">
        <div class="carousel-slide" :style="slideBase(nav, idx)">
          <!-- 媒体背景层：3D 模型 / 视频 / 动图·静图（均自动播放） -->
          <div class="slide-media" v-if="nav.image">
            <model-viewer
              v-if="mediaType(nav.image) === 'model' && isMediaActive(idx)"
              :src="nav.image"
              auto-rotate
              autoplay
              camera-controls
              disable-zoom
              interaction-prompt="none"
              shadow-intensity="0.6"
              exposure="0.9"
              class="slide-model"
            ></model-viewer>
            <video
              v-else-if="mediaType(nav.image) === 'video' && isMediaActive(idx)"
              :src="nav.image"
              autoplay
              muted
              loop
              playsinline
              preload="auto"
              class="slide-video"
            ></video>
            <img v-else-if="isImageMedia(nav.image)" :src="nav.image" :alt="nav.title" class="slide-img" />
          </div>
          <!-- 遮罩渐变：保证任意媒体之上文字可读 -->
          <div class="slide-scrim" v-if="nav.image"></div>
          <div class="slide-content">
            <el-tag v-if="nav.badge" type="danger" size="large" effect="dark" round class="slide-tag">
              <el-icon><component :is="resolveIcon(nav.icon)" /></el-icon> {{ nav.badge }}
            </el-tag>
            <h2 class="slide-title">{{ nav.title }}</h2>
            <p class="slide-desc" v-if="nav.subtitle">{{ nav.subtitle }}</p>
            <div class="slide-features" v-if="nav._highlights && nav._highlights.length">
              <span v-for="(h, hi) in nav._highlights" :key="hi"><el-icon><CircleCheck /></el-icon> {{ h }}</span>
            </div>
            <el-button type="primary" size="large" round class="slide-btn" @click="handleNavClick(nav)">{{ btnText(nav) }}</el-button>
          </div>
          <div class="slide-emoji" v-if="!nav.image">
            <el-icon :size="150"><component :is="resolveIcon(nav.icon)" /></el-icon>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 👇👇👇 只需添加这一行！放在 el-carousel 后面、carousel-container 内部 👇👇👇 -->
    <!-- <div id="carousel-sentinel" style="height: 1px; width: 100%; pointer-events: none;" /> -->
    
  </div>
</section>


    <!-- ========== 定制化能力（全链条服务） ========== -->
    <section class="capability-section">
      <div class="section-container">
        <div class="capability-head">
          <span class="section-eyebrow light">Customized Service</span>
          <h2>从芯片选型到工程监测方案的全链条定制</h2>
          <p>标准产品为基础 · 微定制为特色 · 平台化与工程化交付为核心能力</p>
        </div>
        <div class="capability-steps">
          <div class="cap-step" v-for="(step, idx) in capSteps" :key="step.title">
            <div class="cap-step-no">{{ String(idx + 1).padStart(2, '0') }}</div>
            <h4>{{ step.title }}</h4>
            <p>{{ step.desc }}</p>
          </div>
        </div>
        <div class="capability-cards">
          <div class="cap-card" v-for="card in capCards" :key="card.title">
            <el-icon :size="30"><component :is="card.icon" /></el-icon>
            <h4>{{ card.title }}</h4>
            <p>{{ card.desc }}</p>
          </div>
        </div>
      </div>
    </section>


    <!-- ========== 产品分类快捷入口 ========== -->
<!--    <section class="category-strip">-->
<!--      <div class="section-container">-->
<!--        <div class="category-chips">-->
<!--          <div class="category-chip" v-for="cat in rootCategories" :key="cat.id" @click="goToCategory(cat.code)">-->
<!--            <el-icon :size="18"><component :is="resolveCatIcon(cat.icon)" /></el-icon>-->
<!--            <span>{{ cat.name }}</span>-->
<!--          </div>-->
<!--          <div class="category-chip category-chip&#45;&#45;all" @click="goToProducts">-->
<!--            <span>全部产品</span>-->
<!--            <el-icon :size="16"><ArrowRight /></el-icon>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!-- ========== 热销产品 ========== -->
    <section class="hot-products-section">
      <div class="section-container">
        <div class="section-head-row">
          <div class="section-head-left">
            <span class="section-eyebrow">Featured Products</span>
            <h2>精选产品</h2>
            <p>经过工程现场验证的监测设备与智能终端，按推荐权重排序</p>
          </div>
          <div class="section-head-action" @click="goToProducts">
            查看全部产品 <el-icon><ArrowRight /></el-icon>
          </div>
        </div>
        <div class="hot-grid" v-loading="hotLoading">
          <div class="hot-card" v-for="p in hotList" :key="p.id" @click="goToProductDetail(p.id)">
            <div class="hot-media">
              <img :src="p.image || placeholderImg" :alt="p.name" loading="lazy" @error="onImgError" />
              <span v-if="p.tag" :class="['hot-badge', p.tag === 'hot' ? 'hot-badge--hot' : 'hot-badge--blue']">{{ tagLabel(p.tag) }}</span>
            </div>
            <div class="hot-body">
              <div class="hot-model" v-if="p.model">{{ p.model }}</div>
              <h3>{{ p.name }}</h3>
              <p>{{ p.description || '工程结构监测终端，支持量程、接口、供电与通信方式定制' }}</p>
              <div class="hot-foot">
                <span class="hot-link">查看详情 <el-icon><ArrowRight /></el-icon></span>
              </div>
            </div>
          </div>
          <div class="hot-empty" v-if="!hotLoading && hotList.length === 0">
            <el-empty description="产品上架中，敬请期待" :image-size="120" />
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 行业解决方案 ========== -->
    <section class="industry-section">
      <div class="section-container">
        <div class="section-head-row">
          <div class="section-head-left">
            <span class="section-eyebrow">Solutions</span>
            <h2>解决方案</h2>
            <p>面向不同结构类型与病害问题的定制化监测与智能诊断方案</p>
          </div>
          <div class="section-head-action" @click="goToSolutionsPage">
            全部解决方案 <el-icon><ArrowRight /></el-icon>
          </div>
        </div>
        <div class="sol-track-wrap" v-loading="solLoading" @mouseenter="stopSol" @mouseleave="startSol">
          <div class="sol-track" ref="solTrackRef" :style="solTrackStyle">
            <div class="sol-card" v-for="(sol, idx) in solLoopCards" :key="'sc' + idx" :style="solCardStyle" @click="goToSolutionDetail(sol.id)">
              <img v-if="sol.image || sol.banner" class="sol-card-img" :src="sol.image || sol.banner" :alt="sol.name" loading="lazy" @error="onImgError" />
              <div v-else class="sol-card-img sol-card-ph"><el-icon :size="44"><Connection /></el-icon></div>
              <div class="sol-card-mask">
                <h3>{{ sol.name }}</h3>
                <span class="sol-card-go">进入方案 <el-icon><ArrowRight /></el-icon></span>
              </div>
            </div>
          </div>
          <div class="sol-dots" v-if="topSolutions.length > SOL_VIEW">
            <span v-for="n in topSolutions.length" :key="'sd' + n" :class="['sol-dot', { active: (solIndex % topSolutions.length) === (n - 1) }]" @click="goSolDot(n - 1)"></span>
          </div>
        </div>
        <el-empty v-if="!topSolutions.length && !solLoading" description="解决方案整理中，敬请期待" :image-size="100" />
      </div>
    </section>


    <!-- ========== CTA 区域 ========== -->
    <section class="cta-section">
      <div class="section-container cta-container">
        <el-row justify="center">
          <el-col :xs="24" :lg="16">
            <div class="cta-content">
              <el-tag type="danger" size="large" effect="dark" round>
                <el-icon><Star /></el-icon> 全流程定制化服务
              </el-tag>
              <h2>需要结构健康监测方案？</h2>
              <p>从需求研判、设备定制到现场实施与持续运维，专业团队全程支持</p>
              <div class="cta-buttons">
                <el-button size="large" round @click="handleContact">
                  <el-icon><Message /></el-icon> 邮箱咨询
                </el-button>
                <el-button size="large" round @click="goToSolutionsPage">
                  查看解决方案 <el-icon><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- ========== 页脚 ========== -->
<!-- ========== 页脚 ========== -->
<footer class="footer">
  <div class="footer-container">
    <el-row :gutter="40" class="footer-row">
      <el-col :xs="24" :sm="8" :md="6">
        <div class="footer-brand">
          <div class="logo">
            <div class="logo-icon-wrapper">
              <img src="@/assets/logo.png" alt="青帧智维科技" class="logo-img" />
            </div>
            <span class="logo-text">青帧智维科技</span>
          </div>
          <p>工程结构健康监测 · 定制化设备与智能诊断服务</p>
        </div>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <h4>产品分类</h4>
        <ul>
          <li v-for="l in footerProductLinks" :key="l.path">
            <el-link :underline="false" type="info" @click="goToPath(l.path)">{{ l.label }}</el-link>
          </li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <h4>行业方案</h4>
        <ul>
          <li v-for="l in footerSolutionLinks" :key="l.path">
            <el-link :underline="false" type="info" @click="goToPath(l.path)">{{ l.label }}</el-link>
          </li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <h4>服务支持</h4>
        <ul>
          <li v-for="l in footerSupportLinks" :key="l.path">
            <el-link :underline="false" type="info" @click="goToPath(l.path)">{{ l.label }}</el-link>
          </li>
        </ul>
      </el-col>
      <el-col :xs="24" :sm="8" :md="6">
        <h4>联系我们</h4>
        <div class="contact-info">
          <p><el-icon><Message /></el-icon> qingzhenjiance@163.com</p>
          <p><el-icon><Location /></el-icon> 常州 · 长三角碳纤维及复合材料技术创新中心</p>
        </div>
      </el-col>
    </el-row>
    <el-divider style="border-color: rgba(255,255,255,0.08);" />
    <div class="footer-bottom">
      <span>© 2026 青帧智维科技 · 智能化监测设备研发部</span>
      <span>长三角碳纤维及复合材料技术创新中心</span>
    </div>
    <!-- 备案信息 -->
    <div class="footer-beian">
      <!-- ICP备案 -->
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link icp-beian">
        <img src="@/assets/icp-beian.png" alt="ICP备案" class="beian-icon icp-icon" />
        苏ICP备2026055291号-1
      </a>
      <span class="beian-divider">|</span>
      <!-- 公安备案 -->
      <a href="http://www.beian.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link police-beian">
          <img src="@/assets/gongan-beian.png" alt="公安备案" class="beian-icon police-icon" />
          <span>公安备案：正在备案中</span>
        </a>
    </div>
  </div>
</footer>

    <!-- ========== 回到顶部 ========== -->
    <el-backtop :right="40" :bottom="40" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import AppHeader from '@/components/AppHeader.vue'  // 引入导航栏组件
import { ElMessage } from 'element-plus'
import { getActiveNavbar } from '@/api/navbar'
import { getProducts, getCategories } from '@/api/product'
import { getHotIndustries, getSolutionsPage } from '@/api/solution'
import { resolveIcon } from '@/utils/navIcons'
import {
  Bell,
  CaretBottom,
  User,
  Setting,
  SwitchButton,
  Right,
  VideoCamera,
  Monitor,
  Connection,
  DataLine,
  Phone,
  Message,
  Grid,
  Document,
  Wallet,
  HomeFilled,
  Cloudy,
  ShoppingCart,
  Sunny,
  Crop,
  Collection,
  TrendCharts,
  Share,
  OfficeBuilding,
  Timer,
  Promotion,
  Calendar,
  Star,
  Location,
  Van,
  CircleCheck,
  ArrowRight,
  Cpu,
  Box,
  EditPen,
  ColdDrink,
  DataAnalysis,
  Management,
  ShoppingBag,
  FirstAidKit,
  School,
  Suitcase,
  Tickets
} from '@element-plus/icons-vue'

const router = useRouter()
const userStore = useUserStore()

const activeMenu = ref('1')
const defaultAvatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

// ===== 首页轮播（后台导航配置驱动，无数据时用默认兜底） =====
const navbarItems = ref([])
const SLIDE_GRADIENTS = [
  'linear-gradient(135deg,#4F46E5 0%,#7C3AED 100%)',
  'linear-gradient(135deg,#0f3460 0%,#1a1a2e 100%)',
  'linear-gradient(135deg,#10b981 0%,#059669 100%)',
  'linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)'
]
const FALLBACK_SLIDES = [
  { title: '智能工业网关 Pro', subtitle: '毫秒级响应 · 边缘计算 · 支持5G/以太网', badge: '新品首发', icon: 'Promotion', highlights: '工业级设计, 双网冗余, 云端管理', linkUrl: '/products' },
  { title: '环境监测传感器', subtitle: '高精度温湿度 · PM2.5 · 噪声 · 光照', badge: '热销爆款', icon: 'Star', highlights: '多合一集成, 低功耗, 无线传输', linkUrl: '/products' },
  { title: '设备预测性维护', subtitle: 'AI 故障诊断 · 降低停机时间 40%', badge: '智慧工厂', icon: 'OfficeBuilding', highlights: '实时监控, 智能告警, 数据分析', linkUrl: '/solutions' },
  { title: '一站式物联网平台', subtitle: '设备接入 · 数据采集 · 智能分析 · 安全可靠', badge: '万物互联', icon: 'Connection', highlights: '百万级连接, 99.99% 可用性, 端到端加密', linkUrl: '', action: 'dashboard' }
]
const normalizeSlide = (nav) => ({
  ...nav,
  _highlights: nav.highlights ? String(nav.highlights).split(/[,，]/).map(s => s.trim()).filter(Boolean) : []
})
const slides = computed(() => {
  const src = navbarItems.value.length ? navbarItems.value : FALLBACK_SLIDES
  return src.map(normalizeSlide)
})
// ===== 轮播媒体类型识别：静图 / 动图(GIF/APNG/WebP) / 视频 / 3D 模型 =====
const mediaType = (url) => {
  if (!url) return 'none'
  const ext = String(url).split('?')[0].split('.').pop().toLowerCase()
  if (ext === 'glb' || ext === 'gltf') return 'model'
  if (ext === 'mp4' || ext === 'webm' || ext === 'mov') return 'video'
  if (ext === 'gif' || ext === 'apng' || ext === 'webp') return 'animated'
  return 'image'
}
const isImageMedia = (url) => { const t = mediaType(url); return t === 'image' || t === 'animated' }

// 幻灯片基底：有媒体时用深色底（媒体元素覆盖其上）；无媒体时用渐变兜底
const slideBase = (nav, idx) => {
  if (nav.image) return { background: '#0b0e1f' }
  return { background: SLIDE_GRADIENTS[idx % SLIDE_GRADIENTS.length] }
}

// ===== 重媒体（视频/3D）仅挂载“当前页 ± 1”，省带宽与 GPU =====
const activeIndex = ref(0)
const onCarouselChange = (cur) => { activeIndex.value = cur }
const isMediaActive = (idx) => {
  const n = slides.value.length
  if (n <= 3) return true
  const diff = Math.abs(idx - activeIndex.value)
  return Math.min(diff, n - diff) <= 1
}

// ===== 3D 查看器懒加载：仅当确实存在 3D 幻灯片时才加载（独立 chunk，平时零带宽） =====
const needsModelViewer = computed(() => slides.value.some(s => mediaType(s.image) === 'model'))
watch(needsModelViewer, (need) => {
  if (need) import('@google/model-viewer').catch(e => console.warn('3D viewer 加载失败', e))
}, { immediate: true })
const btnText = (nav) => {
  if (nav.action === 'dashboard') return '立即体验'
  if (nav.productId) return '查看产品'
  if (nav.solutionId) return '了解方案'
  return (nav.linkUrl && /^https?:\/\//i.test(nav.linkUrl)) ? '立即访问' : '查看详情'
}
const loadNavbar = async () => {
  try {
    const res = await getActiveNavbar()
    navbarItems.value = Array.isArray(res.data) ? res.data : []
  } catch (e) {
    console.warn('load navbar failed', e)
  }
}
const handleNavClick = (nav) => {
  if (nav.action === 'dashboard') { goToDashboard(); return }
  let url = nav.linkUrl
  if (!url && nav.productId) url = '/product/' + nav.productId
  if (!url && nav.solutionId) url = '/solution/' + nav.solutionId
  if (!url) return
  if (/^https?:\/\//i.test(url)) window.open(url, '_blank')
  else router.push(url)
}

// ========== 首页动态数据（分类 / 热销产品 / 行业方案） ==========
const rootCategories = ref([])
const hotList = ref([])
const hotLoading = ref(false)
const industries = ref([])
const topSolutions = ref([])
const solLoading = ref(false)

// 产品缺省占位图（内联 SVG，避免裂图）
const placeholderImg = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">' +
  '<rect width="400" height="300" fill="#EEF3FC"/>' +
  '<g fill="none" stroke="#B9CCEA" stroke-width="6" stroke-linecap="round">' +
  '<rect x="140" y="96" width="120" height="88" rx="10"/>' +
  '<circle cx="200" cy="140" r="24"/>' +
  '<path d="M118 214h164"/></g>' +
  '<text x="200" y="252" font-size="16" fill="#8AA3C7" text-anchor="middle" font-family="sans-serif">QC · 监测设备</text></svg>'
)
const onImgError = (e) => { e.target.src = placeholderImg }

// 分类图标映射（后台 icon 字段为图标名，未匹配时兜底）
const ICON_POOL = {
  Monitor, Cpu, Box, Grid, Sunny, Crop, ColdDrink, DataAnalysis, Management,
  ShoppingBag, FirstAidKit, School, Suitcase, Tickets, OfficeBuilding,
  HomeFilled, Connection, DataLine, ShoppingCart, Van, Document, Collection,
  TrendCharts, Promotion, Star, Timer, Wallet, Cloudy, VideoCamera
}
const resolveCatIcon = (icon) => ICON_POOL[icon] || Connection

// 行业图标映射（按行业名称关键词匹配）
const IND_ICON_MAP = {
  '仓储物流': Box, '工业智造': Cpu, '光伏新能源': Sunny, '楼宇园区': OfficeBuilding,
  '农业畜牧': Crop, '水务暖通': ColdDrink, '智慧城市': Monitor, '智慧电网': DataAnalysis,
  '智慧工厂': Grid, '智慧金融': Management, '智慧零售': ShoppingBag, '智能家居': HomeFilled,
  '医疗健康': FirstAidKit, '教育科研': School, '能源矿产': Suitcase, '交通运输': Van, '文旅体育': Tickets
}
const resolveIndustryIcon = (name) => {
  if (!name) return Connection
  for (const key of Object.keys(IND_ICON_MAP)) {
    if (name.includes(key)) return IND_ICON_MAP[key]
  }
  return Connection
}

const tagLabel = (tag) => ({ hot: '热销', new: '新品', recommend: '推荐' }[tag] || tag)

// 定制化服务六步链（源自研发部能力介绍）
const capSteps = ref([
  { title: '芯片模组选型', desc: '按监测对象与精度需求选定传感芯片与采集模组' },
  { title: '传感终端定制', desc: '量程、接口、供电与防护等级的微定制开发' },
  { title: '通信边缘接入', desc: '5G / LoRa / 以太网多链路接入与边缘计算' },
  { title: '平台数据接入', desc: '监测数据统一上云，标准化清洗与存储' },
  { title: '算法分析预警', desc: 'AI 驱动的数据分析与结构安全预警' },
  { title: '工程监测方案', desc: '现场实施、交付与持续运维的整体方案' }
])

const capCards = ref([
  { icon: Cpu, title: '技术驱动型企业', desc: '依托院士团队与高校科研资源，深耕裂纹、应变、振动、声发射与结构胶老化五大监测方向' },
  { icon: EditPen, title: '定制化服务商', desc: '以标准产品为基础、微定制为特色，快速响应个性化监测需求' },
  { icon: TrendCharts, title: 'AI 赋能型组织', desc: '平台化与工程化交付为核心能力，智能诊断贯穿监测全生命周期' }
])

// 页脚动态链接
const footerProductLinks = computed(() =>
  rootCategories.value.slice(0, 6).map(c => ({ label: c.name, path: '/products?category=' + c.code }))
)
const footerSolutionLinks = computed(() =>
  industries.value.slice(0, 6).map(i => ({ label: i.industryName, path: '/solutions?industryIds=' + i.id }))
)
const footerSupportLinks = ref([
  { label: '文档中心', path: '/wikis' },
  { label: '关于我们', path: '/about' },
  { label: '登录 / 注册', path: '/login' }
])

// 响应数据兜底提取（兼容 data 为数组或 { list/items/rows } 结构）
const extractList = (response) => {
  const payload = response?.data
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.list)) return payload.list
  if (Array.isArray(payload?.items)) return payload.items
  if (Array.isArray(payload?.rows)) return payload.rows
  return []
}

const loadHomeData = async () => {
  hotLoading.value = true
  const [catRes, hotRes, indRes, solRes] = await Promise.allSettled([
    getCategories(),
    getProducts({ page: 1, pageSize: 6 }),
    getHotIndustries(6),
    getSolutionsPage({ current: 1, size: 5 })
  ])
  if (catRes.status === 'fulfilled') {
    rootCategories.value = extractList(catRes.value).filter(c => !c.parentId)
  }
  if (hotRes.status === 'fulfilled') {
    let list = extractList(hotRes.value)

    hotList.value = list
  }
  if (indRes.status === 'fulfilled') {
    industries.value = extractList(indRes.value)
  }
  solLoading.value = true
  if (solRes.status === 'fulfilled') {
    // /page 直接返回 MyBatis-Plus Page 对象 {records,...}（无 Result 包装），
    // 也可能被 Result 包成 {code,data:{records}}，这里两种都兼容
    const body = solRes.value
    const inner = body?.data
    const solPayload = (inner && (Array.isArray(inner.records) || Array.isArray(inner.list) || Array.isArray(inner))) ? inner : body
    topSolutions.value = Array.isArray(solPayload?.records) ? solPayload.records
      : Array.isArray(solPayload?.list) ? solPayload.list
      : Array.isArray(solPayload) ? solPayload
      : []
  }
  solLoading.value = false
  hotLoading.value = false
}

// 首页内跳转
const goToCategory = (code) => router.push('/products?category=' + code)
const goToSolutionsPage = () => router.push('/solutions')
const goToIndustry = (id) => router.push('/solutions?industryIds=' + id)
const goToSolutionDetail = (id) => router.push('/solution/' + id)


// ========== 解决方案卡片滚动轮播（3 并列 / 5 循环，单张步进无缝回卷） ==========
const SOL_VIEW = 3
const SOL_GAP = 24
const solTrackRef = ref(null)
const solIndex = ref(0)
const solCardW = ref(0)
const solAnimate = ref(true)
let solTimer = null
const solLoopCards = computed(() => {
  const a = topSolutions.value
  if (!a.length) return []
  const v = Math.min(SOL_VIEW, a.length)
  return a.concat(a.slice(0, v))
})
const solTrackStyle = computed(() => ({
  transform: 'translateX(-' + (solIndex.value * (solCardW.value + SOL_GAP)) + 'px)',
  transition: solAnimate.value ? 'transform .6s cubic-bezier(.4,0,.2,1)' : 'none'
}))
const solCardStyle = computed(() => ({ width: solCardW.value ? (solCardW.value + 'px') : 'auto' }))
function measureSolCard() {
  const wrap = solTrackRef.value && solTrackRef.value.parentElement
  if (!wrap) return
  const w = wrap.clientWidth
  if (w > 0) solCardW.value = (w - (SOL_VIEW - 1) * SOL_GAP) / SOL_VIEW
}
function startSol() {
  stopSol()
  if (topSolutions.value.length <= SOL_VIEW) return
  solTimer = setInterval(stepSol, 3800)
}
function stopSol() { if (solTimer) { clearInterval(solTimer); solTimer = null } }
function stepSol() {
  const N = topSolutions.value.length
  if (N <= SOL_VIEW) return
  solAnimate.value = true
  solIndex.value += 1
  if (solIndex.value >= N) {
    setTimeout(() => {
      solAnimate.value = false
      solIndex.value = 0
      void (solTrackRef.value && solTrackRef.value.offsetWidth)
    }, 640)
  }
}
function goSolDot(j) {
  solAnimate.value = true
  solIndex.value = j
  startSol()
}
function onSolResize() { measureSolCard() }
watch(topSolutions, () => {
  solIndex.value = 0
  nextTick(() => { measureSolCard(); startSol() })
})
onMounted(() => { window.addEventListener('resize', onSolResize) })
onBeforeUnmount(() => { window.removeEventListener('resize', onSolResize); stopSol() })
const goToPath = (path) => router.push(path)

// ========== 方法 ==========


const handleMenuSelect = (index) => {
  activeMenu.value = index
}

const CONTACT_EMAIL = 'qingzhenjiance@163.com'

const handleContact = async () => {
  try {
    await navigator.clipboard.writeText(CONTACT_EMAIL)
    ElMessage.success('咨询邮箱已复制：' + CONTACT_EMAIL)
  } catch (e) {
    ElMessage.info('欢迎来信咨询：' + CONTACT_EMAIL)
  }
}

const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/user/profile')
      break
    case 'settings':
      ElMessage.info('账户设置功能开发中...')
      break
    case 'logout':
      handleLogout()
      break
  }
}

const goToLogin = () => {
  router.push('/login')
}

const goToRegister = () => {
 router.push('/login')
}

const goToDashboard = () => {
  if (userStore.isLoggedIn) {
    if (userStore.role === 'admin') {
      router.push('/admin/dashboard')
    } else {
      router.push('/user/dashboard')
    }
  } else {
    router.push('/login')
  }
}

const handleLogout = async () => {
  try {
    userStore.logout()
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    ElMessage.success('已成功退出登录')
    router.push('/')
  } catch (error) {
    ElMessage.error('退出登录失败')
  }
}

onMounted(() => {
  loadNavbar()
  loadHomeData()
})

const goHome = () => {
  router.push('/')
}

const goToProductDetail = (id) => {
  router.push(`/product/${id}`)
}

// 在 Home.vue 的 script 中添加
const goToProducts = () => {
  router.push('/products')
}
</script>

<style scoped>

/* ========== 轮播栏（导航下第一位，放大） ========== */
.carousel-section {
  padding-top: 10px;
}

.carousel-container {
  max-width: 92%; 
  margin: 0 auto;
  padding: 0 40px 40px;
}

.main-carousel {
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 40px 100px rgba(0, 0, 0, 0.15);
}

.main-carousel :deep(.el-carousel__container) {
  height: 720px;  /* 加大高度 */
}

.main-carousel :deep(.el-carousel__indicator) {
  padding: 10px 6px;
}

.main-carousel :deep(.el-carousel__button) {
  width: 48px;
  height: 5px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
}

.main-carousel :deep(.el-carousel__button.is-active) {
  background: #ffffff;
  width: 68px;
}

.carousel-slide {
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 100px;
  flex-wrap: wrap;
}

/* ===== 轮播媒体背景层（3D 模型 / 视频 / 动图·静图） ===== */
.slide-media {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.slide-img,
.slide-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.slide-model {
  width: 100%;
  height: 100%;
  --poster-color: transparent;
  --progress-bar-color: rgba(255,255,255,.35);
}
/* 遮罩渐变：压暗媒体、保证白色文字在任意画面下可读 */
.slide-scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(105deg, rgba(8,10,30,.82) 0%, rgba(8,10,30,.45) 50%, rgba(8,10,30,.18) 100%);
}

.slide-1 {
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
}

.slide-2 {
  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);
}

.slide-3 {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.slide-4 {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

.slide-content {
  position: relative;
  z-index: 2;
  color: #fff;
  max-width: 640px;
}

.slide-tag {
  font-weight: 600;
  padding: 12px 28px;
  margin-bottom: 24px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
}

.slide-title {
  font-size: 60px;
  font-weight: 800;
  margin: 0 0 20px 0;
  letter-spacing: -1.5px;
  color: #fff;
  line-height: 1.1;
}

.slide-desc {
  font-size: 24px;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 24px;
  color: rgba(255, 255, 255, 0.9);
}

.slide-features {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.slide-features span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  color: rgba(255, 255, 255, 0.85);
}

.slide-features .el-icon {
  font-size: 20px;
}

.slide-btn {
  background: #fff;
  color: #4F46E5;
  border: none;
  font-weight: 600;
  padding: 16px 56px;
  font-size: 20px;
  border-radius: 50px;
}

.slide-btn:hover {
  background: #f8f7ff;
  color: #4F46E5;
  transform: scale(1.03);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
}

.slide-emoji {
  font-size: 120px;
  opacity: 0.12;
  color: #fff;
  font-weight: 200;
  user-select: none;
}

/* ========== Hero 区域（移到轮播后面） ========== */
.hero-section {
  background: linear-gradient(135deg, #f0f4ff 0%, #e8ecf8 50%, #e0e8f0 100%);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.hero-wave {
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
}

.hero-wave svg {
  display: block;
  width: 100%;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 60px 32px 80px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.hero-row {
  width: 100%;
  margin: 0;
}

.hero-left {
  padding: 20px 0;
}

.hero-tag-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.hero-tag {
  font-weight: 600;
  padding: 8px 18px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.hero-tag-sub {
  font-weight: 500;
  padding: 8px 18px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.hero-title {
  font-size: 52px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.1;
  margin: 0 0 16px 0;
  letter-spacing: -1px;
}

.hero-title .highlight {
  color: #4F46E5;
  position: relative;
}

.hero-title .highlight::after {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  height: 12px;
  background: rgba(79, 70, 229, 0.15);
  border-radius: 4px;
}

.hero-desc {
  font-size: 18px;
  color: #6b7280;
  line-height: 1.8;
  margin: 0 0 32px 0;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 48px;
}

.hero-btn-primary {
  padding: 14px 40px;
  font-weight: 600;
  font-size: 16px;
}

.hero-btn-secondary {
  padding: 14px 32px;
  font-weight: 500;
  font-size: 16px;
}

.hero-stats {
  display: flex;
  align-items: center;
  gap: 32px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px);
  padding: 20px 32px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.hero-stats .el-divider {
  height: 40px;
  border-color: #e5e7eb;
}

.hero-stats :deep(.el-statistic) {
  --el-statistic-content-font-size: 24px;
  --el-statistic-content-font-weight: 700;
}

.hero-stats :deep(.el-statistic .el-statistic__head) {
  color: #6b7280;
  font-size: 13px;
}

.hero-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-visual {
  position: relative;
  width: 100%;
  max-width: 560px;
}

.hero-image-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
}

.hero-image {
  width: 100%;
  height: 360px;
  display: block;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  border-radius: 20px;
  color: #6b7280;
  gap: 8px;
}

.float-card {
  position: absolute;
  animation: float 6s ease-in-out infinite;
}

.float-card .el-tag {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-1 {
  top: -12px;
  right: -10px;
  animation-delay: 0s;
}

.card-2 {
  bottom: -10px;
  left: -10px;
  animation-delay: 1.5s;
}

.card-3 {
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  animation-delay: 3s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

/* ========== 热销产品 ========== */
.hot-products-section {
  background: #ffffff;
  padding: 20px 0 60px 0;
}

.section-tag {
  font-weight: 600;
}

.products-row {
  margin-bottom: 20px;
}

.product-card {
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  height: 100%;
  transition: all 0.3s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  border-color: #4F46E5;
}

.product-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4F46E5;
}

.product-name {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #1a1a2e;
}

.product-desc {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 1.5;
}

.product-tags {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.product-price {
  font-size: 24px;
  font-weight: 700;
  color: #4F46E5;
  margin-bottom: 16px;
}

.product-btn {
  width: 100%;
  font-weight: 600;
}

.promotion-banner {
  text-align: center;
  margin-top: 40px;
}

.promotion-tag {
  padding: 10px 32px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ========== 合作伙伴 ========== */
.partners-section {
  background: #ffffff;
  padding: 20px 0;
  border-bottom: 1px solid #f1f5f9;
}

.partners-header {
  text-align: center;
  margin-bottom: 16px;
}

.partners-grid .partner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.3s;
  border: 1px dashed #e5e7eb;
  background: #fafafa;
}

.partners-grid .partner-item:hover {
  border-color: #4F46E5;
  background: #f8f7ff;
}

.partner-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #9ca3af;
  font-size: 12px;
}

/* ========== 通用区域 ========== */
.section-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 5px 32px;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-header h2 {
  font-size: 36px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 14px 0 8px 0;
  letter-spacing: -0.5px;
}

/* ========== 产品特性 ========== */
.features-section {
  background: #ffffff;
}

.features-grid {
  margin: 0 -12px;
}

.features-grid :deep(.el-col) {
  padding: 0 12px;
}

.feature-card {
  text-align: center;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  transition: all 0.4s ease;
  height: 100%;
  min-height: 220px;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  border-color: #4F46E5;
}

.feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.feature-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.feature-card p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 12px 0;
}

.feature-link {
  font-weight: 500;
  color: #4F46E5;
  font-size: 14px;
}

/* ========== 数据统计 ========== */
.stats-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.stats-container {
  padding: 64px 32px;
}

.stats-row :deep(.el-col) {
  padding: 0 16px;
}

.stat-box {
  text-align: center;
  padding: 8px;
}

.stat-number-large :deep(.el-statistic) {
  --el-statistic-content-color: #ffffff;
  --el-statistic-content-font-size: 34px;
  --el-statistic-content-font-weight: 700;
}

.stat-title {
  margin-top: 4px;
  margin-bottom: 12px;
}

.stat-title :deep(.el-text) {
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 15px;
}

.stat-box :deep(.el-progress) {
  max-width: 160px;
  margin: 0 auto;
}

.stat-box :deep(.el-progress-bar__inner) {
  border-radius: 4px;
}

/* ========== 解决方案 ========== */
.solutions-section {
  background: #f8fafc;

}

.solutions-tabs {
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.solutions-tabs :deep(.el-tabs__header) {
  background: #f1f5f9;
  margin: 0;
  border-bottom: 1px solid #e5e7eb;
}

.solutions-tabs :deep(.el-tabs__item) {
  font-size: 15px;
  font-weight: 500;
  padding: 0 32px;
  height: 52px;
  line-height: 52px;
}

.solutions-tabs :deep(.el-tabs__item.is-active) {
  color: #4F46E5;
}

.tab-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.solutions-tabs :deep(.el-tabs__content) {
  padding: 24px 28px;
  background: #ffffff;
}

.solution-card {
  text-align: center;
  border-radius: 14px;
  height: 100%;
  min-height: 150px;
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
  border-color: #4F46E5;
}

.solution-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.solution-card h4 {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 6px 0;
}

.solution-card p {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

/* ========== 新闻轮播 ========== */
.news-section {
  background: #ffffff;
}

.news-carousel {
  border-radius: 16px;
  overflow: hidden;
}

.news-carousel :deep(.el-carousel__item) {
  display: flex;
  align-items: center;
  padding: 8px;
}

.news-item {
  background: #f8fafc;
  border-radius: 16px;
  padding: 28px 32px;
  border: 1px solid #f1f5f9;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  width: 100%;
}

.news-item:hover {
  border-color: #4F46E5;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
}

.news-tag {
  margin-bottom: 12px;
}

.news-item h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.news-item p {
  font-size: 15px;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.6;
  flex: 1;
}

.news-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}

.news-date {
  font-size: 13px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
}

.news-item-0 {
  border-top: 4px solid #ef4444;
}

.news-item-1 {
  border-top: 4px solid #f59e0b;
}

.news-item-2 {
  border-top: 4px solid #4F46E5;
}

/* ========== CTA 区域 ========== */
.cta-section {
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
}

.cta-container {
  padding: 80px 32px;
}

.cta-content {
  text-align: center;
  color: #fff;
}

.cta-content h2 {
  font-size: 38px;
  font-weight: 700;
  margin: 16px 0 12px 0;
  letter-spacing: -0.5px;
}

.cta-content p {
  font-size: 18px;
  opacity: 0.85;
  margin-bottom: 32px;
}

.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-buttons .el-button {
  padding: 14px 40px;
  font-size: 16px;
  font-weight: 600;
}

.cta-buttons .el-button--primary {
  background: #fff;
  color: #4F46E5;
  border-color: #ffffff;
}

.cta-buttons .el-button--primary:hover {
  background: #f8f7ff;
  border-color: #f8f7ff;
}

.cta-buttons .el-button:not(.el-button--primary) {
  color: #ef0d0d;
  border-color: rgba(255, 255, 255, 0.3);
}

.cta-buttons .el-button:not(.el-button--primary):hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

/* ========== 页脚 ========== */
.footer {
  background: #0f172a;
  color: rgba(255, 255, 255, 0.7);
  padding: 56px 32px 24px;
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
}

.footer-row {
  margin: 0 -20px;
}

.footer-row :deep(.el-col) {
  padding: 0 20px;
}

.footer-brand .logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.footer-brand .logo-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
}

.footer-brand .logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.footer-brand .logo-text {
  font-size: 20px;
  color: #fff;
}

.footer-brand .logo-text span {
  color: #4F46E5;
}

.footer-brand p {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.footer-social {
  display: flex;
  gap: 8px;
}

.footer-social .el-button {
  border-color: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.5);
}

.footer-social .el-button:hover {
  border-color: #4F46E5;
  color: #4F46E5;
  background: rgba(79, 70, 229, 0.1);
}

.footer h4 {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.footer ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer ul li {
  margin-bottom: 10px;
}

.footer ul li .el-link {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.footer ul li .el-link:hover {
  color: #fff;
}

.contact-info p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.contact-info p .el-icon {
  color: rgba(255, 255, 255, 0.3);
}

.contact-qr {
  margin-top: 12px;
}

.qr-placeholder {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.3);
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.qr-placeholder:hover {
  background: rgba(79, 70, 229, 0.1);
  border-color: #4F46E5;
}

.footer-bottom {
  max-width: 1280px;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

.footer-bottom .el-link {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
}

.footer-bottom .el-link:hover {
  color: rgba(255, 255, 255, 0.7);
}

/* ========== 响应式 ========== */
@media (max-width: 1200px) {
  .slide-title {
    font-size: 40px;
  }
  .hero-title {
    font-size: 42px;
  }
}

@media (max-width: 992px) {
  .nav-menu {
    display: none !important;
  }
  
  .main-carousel :deep(.el-carousel__container) {
    height: 900px;
  }
  
  .carousel-slide {
    padding: 0 40px;
  }
  
  .slide-title {
    font-size: 34px;
  }
  
  .slide-emoji {
    font-size: 72px;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-stats {
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }
  
  .hero-stats .el-divider {
    display: none;
  }
  
  .hero-stats :deep(.el-statistic) {
    --el-statistic-content-font-size: 20px;
  }
  
  .float-card.card-3 {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 16px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .logo-icon-wrapper {
    width: 34px;
    height: 34px;
  }
  
  .carousel-container {
    padding: 16px 16px 24px;
     max-width: 1440px;  /* 改成 1600px 或 100% */
  }
  
  .main-carousel :deep(.el-carousel__container) {
    height: 480px;
  }
  
  .carousel-slide {
    padding: 0 28px;
    justify-content: center;
    text-align: center;
  }
  
  .slide-content {
    max-width: 100%;
  }
  
  .slide-title {
    font-size: 30px;
  }
  
  .slide-desc {
    font-size: 17px;
  }
  
  .slide-features {
    justify-content: center;
    gap: 16px;
  }
  
  .slide-emoji {
    display: none;
  }
  
  .slide-btn {
    padding: 12px 32px;
    font-size: 16px;
  }
  
  .hero-title {
    font-size: 30px;
  }
  
  .hero-desc {
    font-size: 16px;
  }
  
  .hero-stats {
    padding: 16px 20px;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .hero-stats .el-divider {
    display: none;
  }
  
  .section-container {
    padding: 48px 16px;
  }
  
  .section-header h2 {
    font-size: 28px;
  }
  
  .hero-section {
    min-height: auto;
    padding: 20px 0;
  }
  
  .hero-container {
    padding: 40px 16px 60px;
  }
  
  .hero-right {
    display: none;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .solutions-tabs :deep(.el-tabs__item) {
    padding: 0 16px;
    font-size: 13px;
  }
  
  .solutions-tabs :deep(.el-tabs__content) {
    padding: 16px;
  }
  
  .cta-content h2 {
    font-size: 28px;
  }
  
  .footer-row :deep(.el-col) {
    margin-bottom: 24px;
  }
  
  .news-item {
    padding: 20px;
  }
  
  .news-item h3 {
    font-size: 17px;
  }
  
  .stat-number-large :deep(.el-statistic) {
    --el-statistic-content-font-size: 28px;
  }
}

@media (max-width: 576px) {
  .main-carousel :deep(.el-carousel__container) {
    height: 480px;
  }
  
  .carousel-slide {
    padding: 0 20px;
  }
  
  .slide-title {
    font-size: 26px;
  }
  
  .slide-desc {
    font-size: 15px;
  }
  
  .slide-features span {
    font-size: 13px;
  }
  
  .slide-btn {
    padding: 10px 24px;
    font-size: 14px;
    width: 100%;
  }
  
  .slide-tag {
    font-size: 13px;
    padding: 6px 16px;
  }
  
  .hero-buttons {
    flex-direction: column;
  }
  
  .hero-buttons .el-button {
    width: 100%;
  }
  
  .hero-title {
    font-size: 26px;
  }
  
  .hero-tag-group .hero-tag-sub {
    display: none;
  }
  
  .hero-stats :deep(.el-statistic) {
    --el-statistic-content-font-size: 18px;
  }
  
  .features-grid :deep(.el-col) {
    padding: 0 8px;
    margin-bottom: 16px;
  }
  
  .stats-row :deep(.el-col) {
    padding: 0 8px;
    margin-bottom: 16px;
  }
  
  .cta-buttons {
    flex-direction: column;
  }
  
  .cta-buttons .el-button {
    width: 100%;
  }
  
  .solutions-tabs :deep(.el-tabs__item) {
    padding: 0 10px;
    font-size: 12px;
  }
  
  .solutions-tabs :deep(.el-tabs__content) {
    padding: 12px;
  }
  
  .solution-card {
    margin-bottom: 12px;
  }
  
  .news-carousel {
    height: 260px !important;
  }
  
  .product-card {
    margin-bottom: 16px;
  }
}

/* ========== 回到顶部 ========== */
:deep(.el-backtop) {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: none;
}

:deep(.el-backtop:hover) {
  background: #4F46E5;
  color: #fff;
}


/* ========== 分类快捷入口 ========== */
.category-strip { background: #fff; }
.category-strip .section-container { padding: 26px 32px; }
.category-chips { display: flex; flex-wrap: wrap; gap: 12px; }
.category-chip {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 20px; border-radius: 999px;
  background: #F5F8FF; color: #334155; font-size: 14px; font-weight: 500;
  cursor: pointer; transition: all .25s ease; border: 1px solid transparent;
}
.category-chip:hover { background: #2563EB; color: #fff; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(37,99,235,.25); }
.category-chip--all { background: #fff; border: 1px dashed #B9CCEA; color: #2563EB; }
.category-chip--all:hover { background: #2563EB; color: #fff; border-style: solid; }

/* ========== 通用区块标题 ========== */
.section-head-row { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 36px; gap: 16px;   margin-top: 30px; }
.section-eyebrow { display: block; font-size: 12px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; color: #2563EB; margin-bottom: 10px; }
.section-eyebrow.light { color: #7DA6F5; }
.section-head-left h2 { font-size: 32px; font-weight: 800; color: #0F1B33; margin: 0 0 8px; }
.section-head-left p { margin: 0; color: #64748B; font-size: 15px; }
.section-head-action { display: inline-flex; align-items: center; gap: 6px; color: #2563EB; font-size: 14px; font-weight: 600; cursor: pointer; transition: gap .25s ease; white-space: nowrap; }
.section-head-action:hover { gap: 12px; }

/* ========== 热销产品 ========== */
.hot-products-section { background: #F7F9FD; }
.hot-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; min-height: 200px; }
.hot-card { background: #fff; border-radius: 20px; overflow: hidden; cursor: pointer; border: 1px solid #EDF1F7; transition: transform .3s ease, box-shadow .3s ease; }
.hot-card:hover { transform: translateY(-6px); box-shadow: 0 20px 40px rgba(15,27,51,.12); }
.hot-media { position: relative; height: 240px; overflow: hidden; background: #F1F5FB; }
.hot-media img { width: 100%; height: 100%; object-fit: cover; transition: transform .5s ease; }
.hot-card:hover .hot-media img { transform: scale(1.06); }
.hot-badge { position: absolute; top: 12px; left: 12px; padding: 4px 12px; border-radius: 999px; font-size: 12px; font-weight: 700; color: #fff; }
.hot-badge--hot { background: #EF4444; }
.hot-badge--blue { background: #2563EB; }
.hot-body { padding: 22px 24px 24px; }
.hot-model { font-size: 12px; color: #94A3B8; letter-spacing: 1px; margin-bottom: 6px; }
.hot-body h3 { font-size: 18px; font-weight: 700; color: #0F1B33; margin: 0 0 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.hot-body p { font-size: 14px; color: #64748B; line-height: 1.6; margin: 0 0 14px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 42px; }
.hot-link { display: inline-flex; align-items: center; gap: 4px; color: #2563EB; font-size: 14px; font-weight: 600; transition: gap .25s ease; }
.hot-card:hover .hot-link { gap: 10px; }
.hot-empty { grid-column: 1 / -1; }

/* ========== 行业解决方案 ========== */
.industry-section { background: #F7F9FD; }
.industry-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 22px; }
.industry-card { position: relative; background: #fff; border: 1px solid #EDF1F7; border-radius: 16px; padding: 28px 24px; cursor: pointer; transition: all .3s ease; overflow: hidden; }
.industry-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: #2563EB; transform: scaleX(0); transform-origin: left; transition: transform .35s ease; }
.industry-card:hover { transform: translateY(-6px); box-shadow: 0 20px 40px rgba(15,27,51,.10); border-color: #D6E2F7; }
.industry-card:hover::before { transform: scaleX(1); }
.industry-icon { width: 52px; height: 52px; border-radius: 14px; background: #F0F5FF; color: #2563EB; display: flex; align-items: center; justify-content: center; margin-bottom: 18px; transition: all .3s ease; }
.industry-card:hover .industry-icon { background: #2563EB; color: #fff; }
.industry-card h3 { font-size: 17px; font-weight: 700; color: #0F1B33; margin: 0 0 8px; }
.industry-card p { font-size: 13px; color: #64748B; line-height: 1.6; margin: 0 0 16px; }
.industry-more { display: inline-flex; align-items: center; gap: 4px; color: #2563EB; font-size: 13px; font-weight: 600; transition: gap .25s ease; }
.industry-card:hover .industry-more { gap: 10px; }


.capability-section {
  background: #F7F9FD;
}

.capability-head {
  text-align: center;
  margin-bottom: 48px;
}
.capability-head h2 {
  font-size: 32px;
  font-weight: 800;
  color: #1A1A2E; /* 深色标题 */
  margin: 0 0 10px;
}
.capability-head p {
  color: rgba(26, 26, 46, 0.6); /* 深色半透明副标题 */
  font-size: 15px;
  margin: 0;
}

.capability-steps {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  margin-bottom: 40px;
}
.cap-step {
  background: rgba(255, 255, 255, 0.8); /* 白色半透明背景 */
  border: 1px solid rgba(26, 26, 46, 0.1); /* 浅色边框 */
  border-radius: 14px;
  padding: 22px 18px;
  transition: all .3s ease;
}
.cap-step:hover {
  background: #FFFFFF; /* 悬停变纯白 */
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08); /* 加阴影提升层次 */
}
.cap-step-no {
  font-size: 22px;
  font-weight: 800;
  color: #2563EB; /* 保持品牌蓝，但稍微加深 */
  margin-bottom: 12px;
}
.cap-step h4 {
  color: #1A1A2E; /* 深色标题 */
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 8px;
}
.cap-step p {
  color: rgba(26, 26, 46, 0.6); /* 深色半透明正文 */
  font-size: 12.5px;
  line-height: 1.6;
  margin: 0;
}

.capability-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.cap-card {
  background: #FFFFFF; /* 纯白卡片背景 */
  border: 1px solid rgba(37, 99, 235, 0.15); /* 淡蓝色边框 */
  border-radius: 16px;
  padding: 30px 26px;
  transition: transform .3s ease, box-shadow .3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.cap-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08); /* 悬停阴影加深 */
}
.cap-card .el-icon {
  color: #2563EB; /* 品牌蓝加深 */
  margin-bottom: 16px;
}
.cap-card h4 {
  font-size: 18px;
  font-weight: 800;
  color: #1A1A2E; /* 深色标题 */
  margin: 0 0 10px;
}
.cap-card p {
  color: rgba(26, 26, 46, 0.7); /* 深色半透明正文，比步骤区稍深一点 */
  font-size: 13.5px;
  line-height: 1.7;
  margin: 0;
}
/* ========== 解决方案轮播 ========== */
/* ========== 解决方案卡片滚动轮播（3 并列 / 5 循环） ========== */
.sol-track-wrap { position: relative; margin-top: 8px; overflow: hidden; padding: 6px 2px 4px; }
.sol-track { display: flex; gap: 24px; width: max-content; will-change: transform; }
.sol-card {
  position: relative; flex: 0 0 auto; height: 300px; border-radius: 18px; overflow: hidden;
  cursor: pointer; background: linear-gradient(135deg, #0F1B33, #1E3A8A);
  box-shadow: 0 10px 28px rgba(15,27,51,.12);
  transition: box-shadow .3s ease, transform .3s ease;
}
.sol-card:hover { transform: translateY(-4px); box-shadow: 0 20px 44px rgba(37,99,235,.24); }
.sol-card-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; transition: transform .6s ease; }
.sol-card:hover .sol-card-img { transform: scale(1.06); }
.sol-card-ph { display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,.45); background: linear-gradient(135deg, #0F1B33 0%, #1D3B7A 60%, #2563EB 100%); }
.sol-card-mask {
  position: absolute; left: 0; right: 0; bottom: 0;
  display: flex; align-items: flex-end; justify-content: space-between; gap: 12px;
  padding: 56px 22px 20px;
  background: linear-gradient(180deg, rgba(15,27,51,0) 0%, rgba(15,27,51,.78) 100%);
}
.sol-card-mask h3 { margin: 0; font-size: 19px; font-weight: 800; color: #fff; line-height: 1.35; text-shadow: 0 2px 10px rgba(0,0,0,.35); display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.sol-card-go {
  display: inline-flex; align-items: center; gap: 5px; flex-shrink: 0; white-space: nowrap;
  color: #fff; font-size: 12.5px; font-weight: 600;
  background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.3);
  padding: 6px 12px; border-radius: 999px;
  opacity: 0; transform: translateX(-6px); transition: opacity .3s ease, transform .3s ease, gap .25s ease, background .25s ease;
}
.sol-card:hover .sol-card-go { opacity: 1; transform: translateX(0); }
.sol-card:hover .sol-card-go:hover { gap: 9px; background: rgba(37,99,235,.85); }
.sol-dots { display: flex; justify-content: center; gap: 8px; margin-top: 18px; }
.sol-dot { width: 28px; height: 4px; border-radius: 2px; background: #D8E2F2; cursor: pointer; transition: all .3s ease; }
.sol-dot.active { width: 44px; background: #2563EB; }
@media (max-width: 900px) {
  .sol-card { height: 240px; }
  .sol-card-mask h3 { font-size: 16px; }
}

/* ========== 新增区块响应式 ========== */
@media (max-width: 1100px) {
  .hot-grid { grid-template-columns: repeat(2, 1fr); }
  .capability-steps { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 640px) {
  .hot-grid { grid-template-columns: 1fr; }
  .capability-steps { grid-template-columns: repeat(2, 1fr); }
  .capability-cards { grid-template-columns: 1fr; }
  .section-head-row { flex-direction: column; align-items: flex-start; }
  .section-head-left h2 { font-size: 26px; }
}
/* 备案信息样式 */
.footer-beian {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.footer-beian .beian-link {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.footer-beian .beian-link:hover {
  color: rgba(255, 255, 255, 0.8);
}

.footer-beian .beian-divider {
  color: rgba(255, 255, 255, 0.3);
}

/* 备案图标通用样式 */
.footer-beian .beian-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

/* 公安备案图标稍大一些 */
.footer-beian .police-icon {
  width: 20px;
  height: 20px;
}

/* 公安备案项 */
.footer-beian .police-beian {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.footer-beian .beian-text {
  color: rgba(255, 255, 255, 0.5);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .footer-beian {
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }

  .footer-beian .beian-divider {
    display: none;
  }
}
</style>
